import type {FC} from 'react';

import styled, {css} from 'styled-components';

import type {DayConfig} from '../types';

import {getAlphaColor, getColor, ms} from '../../../styles';
import {View} from '../../../uikit/View';

const SDay = styled(View)<{config: Props['config']; isSelected?: boolean}>`
  flex: 1;
  aspect-ratio: 1 / 1;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  ${p =>
    p.config?.color &&
    !p.isSelected &&
    css`
      color: ${getColor(p.config.color)(p)};
    `}

  ${p =>
    p.config?.fill &&
    !p.isSelected &&
    css`
      background-color: ${getAlphaColor(
        p.config.fill.color,
        p.config.fill.alpha ?? 1,
      )(p)};
    `}
  
  ${p =>
    p.config?.fill?.variant === 'stripped' &&
    !p.isSelected &&
    css`
      background: repeating-linear-gradient(
        130deg,
        ${getAlphaColor(p.config.fill.color, p.config.fill.alpha ?? 1)(p)},
        ${getAlphaColor(p.config.fill.color, p.config.fill.alpha ?? 1)(p)} 3px,
        ${getAlphaColor(
            p.config.fill.color,
            p.config.fill.alpha ? p.config.fill.alpha / 2 : 0.5,
          )(p)}
          3px,
        ${getAlphaColor(
            p.config.fill.color,
            p.config.fill.alpha ? p.config.fill.alpha / 2 : 0.5,
          )(p)}
          6px
      );
    `}

  ${p =>
    p.config?.dot &&
    css`
      &::before {
        content: '';
        width: ${ms(4)};
        height: ${ms(4)};
        border-radius: 50%;
        position: absolute;
        left: 50%;
        bottom: ${ms(-4)};
        transform: translateX(-50%);
        background-color: ${p.isSelected
          ? getColor('static.white')(p)
          : getColor(p.config.dot.color || 'global1')(p)};
      }
    `}
`;

type Props = {config?: DayConfig; day: number; isSelected?: boolean};

export const Day: FC<Props> = ({config, day, isSelected, ...rest}) => {
  return (
    <SDay config={config} isSelected={isSelected} {...rest}>
      {day}
    </SDay>
  );
};
